import { render, staticRenderFns } from "./AddProductToCatalog.vue?vue&type=template&id=32dbac2d&scoped=true&"
import script from "./AddProductToCatalog.vue?vue&type=script&lang=js&"
export * from "./AddProductToCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dbac2d",
  null
  
)

export default component.exports